import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../superadmin/AddDistrict.css';
import './ParentFormsDashboard.css';

const ParentFormsDashboard = () => {
  const [schoolLunchSubmission, setSchoolLunchSubmission] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSchoolLunchData();
  }, []);

  const fetchSchoolLunchData = async () => {
    try {
      setLoading(true);

      // Fetch parent's form submissions to check for existing school lunch application
      const submissionsResponse = await axios.get('/api/form-submissions/progress?include_completed=true');

      // Check for existing school lunch submission (NULL form_instance_id with _form_type marker)
      const lunchSubmission = submissionsResponse.data.find(submission =>
        submission.form_instance_id === null &&
        submission.submission_data &&
        submission.submission_data._form_type === 'school-lunch-application' &&
        submission.is_complete
      );

      if (lunchSubmission) {
        setSchoolLunchSubmission(lunchSubmission);
      }
    } catch (error) {
      console.error('Failed to fetch school lunch form data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteSchoolLunch = async () => {
    if (!schoolLunchSubmission) return;

    const confirmed = window.confirm(
      'Are you sure you want to delete your school lunch application? This action cannot be undone.'
    );

    if (!confirmed) return;

    try {
      const submissionId = schoolLunchSubmission.id;
      await axios.delete(`/api/form-submissions/${submissionId}`);
      setSchoolLunchSubmission(null); // Reset state to show "Start Application" again
    } catch (error) {
      console.error('Failed to delete school lunch submission:', error);
      alert('Failed to delete school lunch application. Please try again.');
    }
  };

  return (
    <div className="parent-forms-dashboard">
      <h2>Back to School Forms</h2>

      <div className="form-grid">
        {/* Add New Student Form */}
        <div className="form-card">
          <h3>Add a New Student</h3>
          <p>Register a new student with basic information. Forms can be completed later from My Students.</p>

          <Link
            to="/parent/student-intake/new"
            className="btn-primary"
            style={{ width: 'fit-content' }}
          >
            Add New Student
          </Link>
        </div>

        {/* School Lunch Application */}
        <div className="form-card">
          <h3>School Lunch Application</h3>
          <p>Apply for free or reduced price school meals for your family.</p>

          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
            {schoolLunchSubmission ? (
              <>
                <button
                  onClick={async () => {
                    try {
                      const response = await axios.post('/api/forms/school-lunch-application/generate-pdf',
                        { submissionId: schoolLunchSubmission.id },
                        { responseType: 'blob' }
                      );
                      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                      window.open(url, '_blank');
                    } catch (error) {
                      alert('Failed to generate PDF: ' + (error.response?.data?.error || error.message));
                    }
                  }}
                  className="btn-primary"
                  style={{ width: 'fit-content' }}
                >
                  View PDF
                </button>
                <Link
                  to="/parent/school-lunch/school-lunch-application"
                  className="btn-secondary"
                  style={{
                    width: 'fit-content',
                    background: '#6c757d',
                    color: 'white',
                    textDecoration: 'none',
                    padding: '0.5rem 1rem',
                    borderRadius: '4px',
                    display: 'inline-block'
                  }}
                >
                  Restart Application
                </Link>
                <button
                  onClick={handleDeleteSchoolLunch}
                  className="btn-danger"
                  style={{
                    width: 'fit-content',
                    background: '#dc3545',
                    color: 'white',
                    border: 'none',
                    padding: '0.5rem 1rem',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  Delete Application
                </button>
              </>
            ) : (
              <Link
                to="/parent/school-lunch/school-lunch-application"
                className="btn-primary"
                style={{ width: 'fit-content' }}
              >
                Start Application
              </Link>
            )}
          </div>

          {schoolLunchSubmission && (
            <div style={{
              marginTop: '1rem',
              padding: '0.75rem',
              background: '#d4edda',
              border: '1px solid #c3e6cb',
              borderRadius: '4px',
              fontSize: '0.9rem',
              color: '#155724'
            }}>
              <strong>✓ Application Submitted</strong>
              <br />
              Submitted on {new Date(schoolLunchSubmission.submitted_at).toLocaleDateString()}
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default ParentFormsDashboard;



